import { useEffect } from 'react';

import { useGame } from '@/store/game';
import { notify } from '@/telegram/haptics';

/**
 * Отказ сервера на конкретное нажатие.
 *
 * Экран обязан его показывать: намерение уходит на сервер, решение принимает
 * он, и без этой строки отказ («за столом 2 игрока, партия начинается от 3»,
 * «ход не ваш», обрыв связи) выглядит как мёртвая кнопка. Человек в этот момент
 * жмёт её ещё пять раз и идёт перезапускать приложение.
 *
 * Отказы не копятся: держится последний, тап снимает его. Текст приходит от
 * сервера как есть — решения принимаются по `code`, а формулировка живёт там же,
 * где знают контекст (`../clown-back/api/ws-protocol.md`).
 */
export function RejectionNotice() {
  const rejection = useGame((s) => s.lastRejection);
  const dismiss = useGame((s) => s.dismissRejection);

  // Отказ обязан дойти до человека, который смотрит не в тот угол экрана:
  // в темноте и вполглаза виброотклик замечают раньше красной строки.
  useEffect(() => {
    if (rejection) notify('error');
  }, [rejection?.at]);

  if (!rejection) return null;

  return (
    <button
      type="button"
      onClick={dismiss}
      className="mt-3 min-h-tap w-full appearance-none rounded-none border-2 border-acc bg-panel px-4 py-3 text-left"
    >
      <span className="block text-meta uppercase tracking-widest text-acc">Сервер отказал</span>
      <span className="mt-1 block text-base text-ink">{rejection.message}</span>
    </button>
  );
}
